import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'so',
    fullName: 'Somali',
    nativeName: 'Soomaali',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Wax Cajiiba Ayaa Soo Socda",
    landing_subtitle: "ArgVoid waa app iyo istuudiyaha horumarinta ciyaarta. La soco, wax cusub ayaa soo socda dhawaan!",
    select_language: "Dooro Luuqad",
    search_placeholder: "Raadi luqadaha...",
    terms_title: "Shuruudaha Adeegga",
    policy_title: "Siyaasadda Qarsoonnimada",
    cookies_title: "Siyaasadda Kukiyada",
    terms_content: `
        <strong>1. Ogolaanshaha Shuruudaha</strong><br>
        Markaad gasho ArgVoid, Shuruudaha Adeegga waa la aqbalayaa. Haddii shuruudahan aan lagu heshiin, adeegga waa in aan la isticmaalin.<br><br>

        <strong>2. Platform Isticmaalka</strong><br>
        ArgVoid iyo codsiyadeeda waxa loo bixiyay "sida" ujeeddooyin macluumaad iyo hal abuur leh. Adeegga waa in loo isticmaalo ujeeddooyin sharci ah oo keliya.<br><br>

        <strong>3. Dhaqanka Mamnuucay</strong><br>
        Ka faa'iidaysiga dayacanka goobta, spammingka, ama isku dayga gelitaanka aan la ogolayn ee kaabayaasha waa mamnuuc.<br><br>

        <strong>4. Afeef</strong><br>
        Goobta iyo adeegyada waxa laga yaabaa in wax laga beddelo wakhti kasta ogeysiis la'aan. Ma jiro wax dammaanad ah oo la bixiyay oo ku saabsan wakhtiga la joogo ama la heli karo adeegga.
    `,
    policy_content: `
        <strong>1. Xog ururinta</strong><br>
        Madalku uma baahna aqoonsiga isticmaalaha ama abuurista akoontiga wakhtigan. Ma jiro macluumaad gaar ah (sida magacyada ama cinwaanada iimaylka) oo si firfircoon looga soo ururiyay booqdayaasha.<br><br>

        <strong>2. Isticmaalka Data</strong><br>
        Aasaaska, falanqaynta qarsoodiga ah ayaa la ururin karaa si loo fahmo taraafikada goobta oo loo hagaajiyo codsiyada. Xogtan kuma xidhna aqoonsiga isticmaale ee gaarka ah.<br><br>

        <strong>3. Adeegyada Xisbiga Saddexaad</strong><br>
        Bixiyeyaasha dhinac saddexaad waxaa laga yaabaa in loo isticmaalo martigelinta iyo adeegyada falanqaynta. Hab-dhaqannada gaarka ah ee bixiyayaashan kala duwan ayaa xukuma xogta qarsoodiga ah ee lagu farsameeyo kaabayaashooda.<br><br>

        <strong>4. Data Security</strong><br>
        Tallaabooyin ammaan oo macquul ah ayaa la fuliyay si loo ilaaliyo goobta. Si kastaba ha ahaatee, ma jiro hab lagu gudbiyo internetka oo gebi ahaanba ammaan ah.<br><br>
    `,
    cookies_content: `
        <strong>1. Waa maxay Kukiyada iyo Kaydinta Maxaliga ah?</strong><br>
        Kukiyada iyo kaydinta deegaanka browserka waa faylal yar oo xog ah oo lagu kaydiyay qalabka si loo xasuusto qaabaynta dookhyada booqashooyinka.<br><br>

        <strong>2. Isticmaalka Ujeedada</strong><br>
        Kaydinta Maxalliga ee Browser si adag ayaa loo isticmaalaa si loo badbaadiyo habaynta qaabaynta, sida:<br>
        - Dookhyada luqadda<br>
        - Isku xidhka isticmaalaha (tusaale, qaabaynta ama dejinta mawduuca)<br>
        - Cache codsiga ku meel gaadhka ah<br><br>

        <strong>3. Ma jiro Tracking</strong><br>
        Kukiyada iyo kaydinta maxaliga ah looma isticmaalo xayaysiisyada ama ujeedooyinka dabagalka cid saddexaad. Dhammaan xogta la kaydiyay waxay si adag u tahay shaqada asaasiga ah ee madal.<br><br>

        <strong>4. Control</strong><br>
        Xogta browserka waxa lagu nadiifin karaa wakhti kasta iyada oo loo marayo goobaha browserka, kaas oo dib u dajin doona qaabayn kasta oo maxalli ah.
    `,
    cookie_consent_text: "Waxaan isticmaalnaa cookies-ka aasaasiga ah si aan u hubinno in mareegaha uu si sax ah u shaqeeyo, sida ka dhigista fadhigaaga mid firfircoon, badbaadinta dookha luqadaada, iyo qaabaynta kale ee gaarka ah.",
    read_policy: "Akhri Siyaasadda Kukiyada",
    support_title: "Taageerada Xiriirka",
    support_subject_label: "Mawduuc",
    support_message_label: "Fariinta",
    support_submit_button: "Fariin dir",
    support_hint: "Xusuusin: Tani waxay furi doontaa codsigaaga iimaylka caadiga ah si aad u dirto fariinta.",
    support_success_msg: "Furaya iimaylka abkaaga...",
    support_error_msg: "Waa lagu guul daraystay in la diro fariin Fadlan isku day mar kale hadhow",
    explorer_title: "Explorer",
    history_title: "Taariikhda",
    animation_title: "Animation",
    config_title: "Habaynta",
    tool_mouse: "Dooro (Ctrl+M)",
    tool_brush: "Caday (Ctrl+B)",
    tool_brush_mode: "Beddel Qaabka (Aadg/Nadiif)",
    tool_eraser: "Tirtir (Ctrl+E)",
    tool_brush_size: "Hagaajin Cabirka burushka",
    tool_bucket: "Buuxi (Ctrl+F)",
    tool_eyedropper: "Isha isha",
    tool_grid: "Grid (Ctrl+Shift+B)",
    tool_rotate: "Wareeg (Ctrl+Shift+R)",
    tool_flip_h: "Flip H (Ctrl+Shift+H)",
    tool_flip_v: "Flip V (Ctrl+Shift+V)",
    tool_transpose: "Transpose (Ctrl+Shift+T)",
    label_width: "Ballaca",
    label_height: "Dhererka",
    label_frames: "Tirada Frames",
    label_animation: "Qaabka Animation",
    label_background_color: "Midabka asalka",
    label_interval: "dhexda",
    tool_anim_config: "Habaynta Animation",
    label_new_width: "Balaadh Cusub",
    label_new_height: "Dhererka Cusub",
    label_apply: "Codso",
    label_colors: "Midabada",
    label_size: "Cabbirka",
    label_tolerance: "Dulqaad",
    val_horizontal: "Horizontal",
    val_vertical: "Toosan",
    val_sequence: "Isku xigxiga",
    val_bounce: "Booska",
    val_random: "Random",
    val_solid: "Adag",
    val_clear: "Cad",
    action_add_sheet: "Xaashi cusub",
    action_import: "Soo dejinta",
    action_export: "Dhoofinta",
    action_sort_projects: "Kala sooc",
    sort_date_old: "Ugu Da'da weyn",
    sort_date_new: "Ugu Horeeyay",
    sort_name_az: "Magaca (A-Z)",
    sort_name_za: "Magaca (Z-A)",
    action_new_sprite: "Sprite Cusub",
    action_new_project: "Mashruuc Cusub",
    modal_save_all_title: "Keydi Dhammaan Isbedelada",
    modal_save_all_desc: "Dooro hantida aad kaydinayso:",
    modal_save_selected: "Keydi la doortay",
    action_saved: "Badbaadiyay",
    modal_create_sprite_title: "Abuur Sprite Cusub",
    modal_create_project_title: "Abuur Mashruuc Cusub",
    modal_add_sheet_title: "Ku dar xaashi cusub",
    modal_rename_sheet_title: "Magaca ka bedel xaashida",
    modal_rename_sprite_title: "Dib u magacaw Sprite",
    modal_delete_sprite_title: "Tirtir Sprite",
    modal_delete_project_title: "Tirtir Mashruuca",
    modal_delete_sheet_title: "Tirtir xaashida",
    placeholder_sprite_name: "Magaca",
    placeholder_project_name: "Magaca",
    placeholder_sheet_name: "Magaca",
    placeholder_new_name: "Magaca Cusub",
    action_create: "Abuur",
    action_add: "Kudar",
    action_rename: "Magacaabista",
    action_duplicate: "nuqul",
    action_delete: "Tirtir",
    action_cancel: "Jooji",
    confirm_delete_sprite: "Ma hubtaa inaad doonayso inaad tirtirto sprite this?",
    confirm_delete_project: "Ma hubtaa inaad doonayso inaad tirtirto mashruucan? Dhammaan sprites waa la saari doonaa.",
    confirm_delete_sheet: "Ma hubtaa inaad rabto inaad tirtirto xaashidan?",
    err_select_sprite: "Fadlan marka hore dooro sprite",
    err_select_project: "Fadlan marka hore dooro mashruuc",
    err_name_empty: "Magac ma noqon karo madhan.",
    err_sprite_exists: "sprite magacaas leh ayaa hore u jiray.",
    err_project_exists: "Mashruuc magacaas wata ayaa horay u jiray.",
    err_no_content: "Ma jiro wax la kaydiyo",
    err_no_changes: "Ma jiraan wax isbedel ah oo lagu kaydiyo",
    err_delete_last_sheet: "Ma tirtiri karo xaashida u dambaysa",
    err_extract_frames: "Waa la soo saari kari waayay wax xidhmo",
    err_indexeddb: "Ku guul daraystay in la badbaadiyo gudaha. Barowsarkaaga waxaa laga yaabaa inuusan taageerin IndexedDB.",
    msg_upload_success: "Soo dejinta waa lagu guulaystay: {0}",
    msg_upload_failed: "Soo dejintii waa guuldareystay: {0}",
    msg_save_success: "Badbaadi guul",
    msg_saving: "Keydinaya...",
    msg_multi_save_result: "La kaydiyay {0} hantida {1} guuldarrooyin",
    menu_title: "Menu",
    menu_save: "Badbaadin",
    menu_save_all: "Dhammaan badbaadi",
    menu_support: "Taageerada Xiriirka",
    label_local_storage: "Kaydinta Maxaliga",
    label_sign_in: "Soo gal",
    modal_export_title: "Dhoofinta Sprite",
    label_filename: "Magaca faylka",
    label_format: "Qaabka",
    action_export_confirm: "Dhoofinta",
};

export default translations;
